import type { PaginationQuery } from './types';

function quoteFilterValue(value: string): string {
  const bereinigt = value.trim();
  if (!bereinigt) {
    return '';
  }
  if (/\s|"/.test(bereinigt)) {
    return `"${bereinigt.replace(/"/g, '\\"')}"`;
  }
  return bereinigt;
}

export function buildServerFilter({
  search,
  values,
  from,
  to,
}: {
  search?: string;
  values?: Record<string, string | undefined>;
  from?: string;
  to?: string;
}): string {
  const tokens: string[] = [];

  Object.entries(values ?? {}).forEach(([feld, wert]) => {
    if (!wert || wert === 'alle') {
      return;
    }
    const quoted = quoteFilterValue(wert);
    if (quoted) {
      tokens.push(`${feld}:${quoted}`);
    }
  });

  if (from) {
    tokens.push(`from:${from}`);
  }
  if (to) {
    tokens.push(`to:${to}`);
  }

  const quotedSearch = quoteFilterValue(search ?? '');
  if (quotedSearch) {
    tokens.push(quotedSearch);
  }

  return tokens.join(' ');
}

export function paginationParamsZuApiParams(query?: PaginationQuery): Record<string, unknown> {
  if (!query) {
    return {};
  }

  return {
    ...(query.page ? { page: query.page } : {}),
    ...(query.pageSize ? { page_size: query.pageSize } : {}),
    ...(query.sortBy ? { sort_by: query.sortBy } : {}),
    ...(query.sortOrder ? { sort_order: query.sortOrder } : {}),
    ...(query.filter ? { filter: query.filter } : {}),
    ...(query.ohneUnklare ? { ohneUnklare: query.ohneUnklare } : {}),
  };
}